
import confirm_account from './confirm_account.js';
import installations from './installations.js';
import new_account from './new_account.js';
import new_account_confirmation from './new_account_confirmation.js';
import virtual_machines from './internal/virtual_machines.js';
import sites from './internal/sites.js';
import products from './internal/products.js';
import accounts_installations from './internal/accounts_installations.js';
import accounts from './internal/accounts.js';

export default [
	confirm_account,
	new_account,
	installations,
	new_account_confirmation,
	virtual_machines,
	sites,
	products,
	accounts_installations,
	accounts
];


Grape.on('after_logout', function(e) {
	localStorage.clear();
	console.log('clearing localstorage');
});
